import { baseApi } from "./base";

export interface UserDocument {
  id: number;
  document_type: string;
  collection_name: string;
  legal_id_sub_type?: string;
  file_name: string;
  name: string;
  mime_type: string;
  size: number;
  url: string;
  created_at: string;
  updated_at: string;
}

export const documentApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getUserDocuments: builder.query<
      UserDocument[],
      { userId: number; documentType?: string }
    >({
      extraOptions: {
        isCompanyApi: true,
      },
      query: ({ userId, documentType }) => {
        const url = `users/${userId}/documents`;
        const params = documentType
          ? { document_type: documentType }
          : undefined;

        if (params) {
          const queryString = new URLSearchParams(params).toString();
          return {
            url: `${url}?${queryString}`,
            method: "GET",
          };
        }

        return {
          url,
          method: "GET",
        };
      },
    }),
  }),
  overrideExisting: false,
});

export const { useGetUserDocumentsQuery } = documentApi;
